export const partners = [
  { label: "Bunny CDN", image: "/partners/bunnycdn-logo.png" },
  { label: "Wati", image: "/partners/wati-logo.png" },
  { label: "Shopify", image: "/partners/shopify-logo.png" },
  { label: "Stripe Payment Gateway", image: "/partners/stripe-logo.png" },
  { label: "Razorpay", image: "/partners/razorpay-logo.png" },
  { label: "Godaddy", image: "/partners/godaddy-logo.png" },
  { label: "Ship Rocket", image: "/partners/shiprocket-logo.png" },
  { label: "MSG91", image: "/partners/msg91-logo.png" },
  { label: "Intercom", image: "/partners/intercom-logo.png" },
  { label: "Collect.chat", image: "/partners/collectchat-logo.png" },
  { label: "Azure Microsoft", image: "/partners/microsoftazure-logo.png" },
  { label: "RevenueCat", image: "/partners/revenuecat-logo.png" },
];
